import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { StorageService } from 'src/services/storage';
import { Events } from 'src/utilities/Events';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  currentProject: any;
  project: any;
  userItem: any;

  public mainPages = [
    {
      "icon": "home",
      "title": "Home",
      "url": "/home"
    },
    {
      "icon": "menu-maps-icon",
      "title": "Observations",
      "url": "maps"
    },
    {
      "icon": "menu-atlas-icon",
      "title": "Catalogue",
      "url": "atlas"
    },
    {
      "icon": "menu-species-icon",
      "title": "New Observation",
      "url": "species-reporting"
    },
    {
      "icon": "menu-reports-icon",
      "title": "My Observations",
      "url": "my-reports"
    },
    {
      "ionicon": "list",
      "title": "Projects",
      "url": "projects"
    },
    {
      "ionicon": "globe",
      "title": "Project Minisite",
      "url": "https://citizenscience.lifewatchitaly.eu/catalogue/"
    },
    {
      "ionicon": "log-out",
      "title": "Sign out",
      "url": "/login"
    }
  ];

  constructor(
    private storage: StorageService,
    private events: Events,
    private navCtrl: NavController
  ) {
    this.currentProject = false;

    this.initializeApp();

    this.events.observeEvent('hide-sidemenu').subscribe((data) => {
      this.currentProject = false;
    });
    //this.events.subscribe('show-sidemenu', (data) => {
    this.events.observeEvent('show-sidemenu').subscribe((data) => {
      this.currentProject = true;
    });

    //this.events.subscribe('user-login', (data) => {
    this.events.observeEvent('user-login').subscribe((data) => {
      this.storage.getUser().then((user) => {
        this.userItem = user;
      });
    });
  }

  async initializeApp() {
    console.log("PASSO DA APP COMPONENT");

    this.currentProject = await this.storage.getCurrentProject();
    this.project = await this.storage.getCurrentProject();

    this.userItem = await this.storage.getUser();

    console.log("userItem", this.userItem);

    /*if (!this.userItem) {
      this.navCtrl.navigateRoot('/login');
    }*/

    /*this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });*/


  }

  async gotoMenuPage(page) {
    if (page.includes('://'))
      window.open(page + this.project.post_name, '_blank').focus();
    else {
      if (this.project && page == '/home')
        page = page + '/' + this.project.post_name;
      //this.router.navigate([page]);
      this.navCtrl.navigateRoot(page);
    }

  }

  async gotoUserDashboard() {
    window.open("https://citizenscience.lifewatchitaly.eu/login/", '_blank').focus();
  }

}
